<template>
  <img
    v-if="card.file"
    :src="card.file.url"
    :alt="card.name"
    class="w-72 rounded-2xl object-cover shadow shrink-0"
    :style="{ aspectRatio: LOYALTY_CARD_ASPECT_RATIO }"
  >
  <div
    v-else
    class="w-72 rounded-2xl p-5 text-white flex items-center justify-center text-center bg-gradient-to-br from-primary-dark to-primary shadow shrink-0"
    :style="{ aspectRatio: LOYALTY_CARD_ASPECT_RATIO }"
  >
    <span class="text-sm font-semibold">{{ card.name }}</span>
  </div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import {LOYALTY_CARD_ASPECT_RATIO, LoyaltyCardMembership} from "@/loyalty-card/interfaces/hds/LoyaltyCard";

const props = defineProps<{
    membership: LoyaltyCardMembership;
}>();

const card = computed(() => props.membership.loyalty_card);
</script>
